/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   trueReducer that always returns true
 */

import { alwaysReducer } from './alwaysReducer'

export const trueReducer = alwaysReducer<true>(true)
